import * as Cookies from "js-cookie";

export type PlayerId = string;

class Auth {
    private currentPlayerId: PlayerId;

    private currentPlayerName: string;

    constructor() {
        // TODO get ID from server
        // TODO not just IDs, have secret.

        const idCookie = Cookies.get("userId");
        const nameCookie = Cookies.get("userName");
        if (idCookie) {
            this.currentPlayerId = idCookie;
            this.currentPlayerName = nameCookie || "Unknown";
        } else {
            this.currentPlayerId = `${Math.floor(Math.random() * 10000)}`;
            Cookies.set("userId", this.currentPlayerId);

            this.currentPlayerName =
                prompt("What is your name?") ||
                `Player ${Math.floor(Math.random() * 100)}`;
            Cookies.set("userName", this.currentPlayerName);
        }
    }

    getCurrentPlayerId(): PlayerId {
        return this.currentPlayerId;
    }

    getCurrentPlayerName(): PlayerId {
        return this.currentPlayerName;
    }
}

export default Auth;
